import {
    IEmail,
    IEmailConversationInfoEvent,
    IInboundEmailEvent,
} from '@dxp/core/models';

export const hasConversationInfoChanged = (
    existing: IEmailConversationInfoEvent,
    updated: IEmailConversationInfoEvent,
): boolean => {
    return (
        existing.previewTimerExpiresAt !== updated.previewTimerExpiresAt ||
        existing.conversation.draftOutboundEmailMessage !==
            updated.conversation.draftOutboundEmailMessage ||
        existing.conversation.channelAddress !==
            updated.conversation.channelAddress ||
        existing.conversation.threadId !== updated.conversation.threadId ||
        existing.conversation.channelId !== updated.conversation.channelId ||
        existing.conversationId !== updated.conversationId
    );
};

export const mapToEmail = (inboundEmail: IInboundEmailEvent): IEmail => {
    return {
        messageId: inboundEmail.id,
        conversationId: inboundEmail.conversationId,
        threadId: inboundEmail.threadId,
        creationDate: inboundEmail.creationDate,
        subject: inboundEmail.subject,
        from: inboundEmail.from,
        bodyId: inboundEmail.bodyId,
        bodyPreview: inboundEmail.bodyPreview,
        replyTo: inboundEmail.replyTo || [],
        toRecipients: inboundEmail.toRecipients || [],
        ccRecipients: inboundEmail.ccRecipients || [],
        bccRecipients: inboundEmail.bccRecipients || [],
        attachments: inboundEmail.attachments || [],
        senderType: null,
    };
};

export const sortByCreationDesc = (messages: IEmail[]): IEmail[] => {
    return [...messages].sort(
        (a, b) =>
            new Date(b.creationDate).getTime() -
            new Date(a.creationDate).getTime(),
    );
};

export const dedupeById = (messages: IEmail[]): IEmail[] => {
    const seen = new Set<string | undefined>();
    const out: IEmail[] = [];
    for (const m of messages) {
        if (!m) continue;
        if (seen.has(m.messageId)) continue;
        seen.add(m.messageId);
        out.push(m);
    }
    return out;
};

export function areMessagesEquivalent(
    a: readonly IEmail[] | undefined,
    b: readonly IEmail[] | undefined,
): boolean {
    if (a === b) return true;

    if (!a || !b) return false;

    const length = a.length;
    if (length !== b.length) return false;

    for (let i = 0; i < length; i++) {
        if (a[i].messageId !== b[i].messageId) {
            return false;
        }
    }

    return true;
}
